import { Component, OnInit, OnDestroy } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentLanguage = 'en';
  isMenuOpen = false;
  private destroy$ = new Subject<void>();

  constructor(private i18nService: I18nService) { }

  ngOnInit(): void {
    this.i18nService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.currentLanguage = lang;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleLanguage(): void {
    const newLang = this.currentLanguage === 'en' ? 'uk' : 'en';
    this.i18nService.setLanguage(newLang);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  getTranslation(key: string): string {
    return this.i18nService.getTranslation(key);
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      this.isMenuOpen = false; // Close mobile menu after click
    }
  }
}
